import { authorizedBillingFetch } from 'app/axios/billing'

export const getPaymentMethods = (rootDomainId: string) =>
  authorizedBillingFetch.get(`/root-domain/${rootDomainId}/payment-methods`)

export const detachPaymentMethod = (id: string, rootDomainId: string) =>
  authorizedBillingFetch.delete(
    `/root-domain/${rootDomainId}/payment-methods/${id}`
  )

export const setDefaultPaymentMethod = (id: string, rootDomainId: string) =>
  authorizedBillingFetch.post(
    `/root-domain/${rootDomainId}/payment-methods/${id}/set-default`
  )
